/**
 * The Webflow export's runtime (`window._Agapae`, loaded by index.html) binds
 * the scroll animations, the story slider and the mobile nav to DOM nodes, so
 * it has to be re-bound over whatever React has drawn — once the invitation is
 * on the page, and again whenever its set of sections changes. A no-op until
 * the runtime has loaded.
 */
export function reinitWebflow() {
  const runtime = window._Agapae;
  if (!runtime?.require) return;
  const animations = runtime.require("animations");
  const slider = runtime.require("slider");
  if (animations) {
    runtime.destroy();
    runtime.ready();
    animations.init();
  }
  if (slider) {
    slider.redraw();
  }
}

/**
 * Re-bind the runtime under a page that is already showing (the editor's
 * preview, after its sections change). Re-binding replays the runtime's
 * page-load interaction, which hides `.main` and slides the nav up again — on
 * desktop it never animates them back — so put both straight back, with
 * their transitions held off, before the browser paints.
 */
export function rebindWebflow() {
  reinitWebflow();
  const main = document.querySelector(".main");
  const navContainer = document.querySelector(".nav-container");
  const shown = [main, navContainer].filter(Boolean);
  shown.forEach((el) => {
    el.style.transition = "none";
  });
  if (main) main.style.opacity = 1;
  if (navContainer) navContainer.style.transform = "translate3d(0, 0, 0)";
  // Apply the restored values before the transitions come back.
  void document.body.offsetHeight;
  shown.forEach((el) => {
    el.style.transition = "";
  });
}

/**
 * Fade the nav and the invitation in. Both start hidden (index.css, and the
 * `.main` opacity the template renders) so nothing flashes before the
 * runtime above has bound them.
 */
export function revealInvitation() {
  requestAnimationFrame(() => {
    const navbar = document.querySelector(".navbar");
    if (navbar) {
      navbar.classList.add("is-visible");
    }

    const mainElement = document.querySelector(".main");
    if (mainElement) {
      mainElement.style.opacity = 1;
    }

    const navContainer = document.querySelector(".nav-container");
    if (navContainer) {
      navContainer.style.transform = "translate3d(0, 0, 0)";
    }
  });
}
